import React, { useEffect, useState } from 'react';
import { Container, Dropdown, Form, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import * as DateFns from 'date-fns';
import { GoogleLogout } from 'react-google-login';

import { FORCE_SCOPE, FORMAT_DATE_ROUTE, GOOGLE_CLIENT_ID, S_B_ROLES, TEAMS_COLORS } from '../../config/constants';
import {
  formatDateRoute,
  isCC,
  isMLAX,
  isNCAA,
  isNCAAAllSports,
  isTA,
  logout,
  saveDataPlayersOnLocalStorage
} from '../../helpers';
import { startApiKeyOAuth } from '../../helpers/apiKeyOAuth';
import { buildPlayerData } from '../../store/actions';
import {
  useDataPlayersDispatch,
  useLoadingState,
  useSearchesState,
  useUserDispatch,
  useUserState
} from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import Loader from '../Shared/Loader';

let indexSearch = 0;

const NavBar = () => {
  const user = useUserState();
  const { pathname, history } = useRouter();
  const { playersData: players } = useSearchesState();
  const { logoutUser } = useUserDispatch();
  const { replaceDataPlayers } = useDataPlayersDispatch();
  const [shownBar, setShownBar] = useState(false);
  const [detectedPlayers, setDetectedPlayers] = useState<JSX.Element[]>([]);
  const current = useLoadingState(FORCE_SCOPE.PLAYERS_SEARCH_DATA_NAVBAR);
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const failure = (response?: any) => {
    console.error('Google Logout failed:', response);
  };

  const onPath = (paths: string[]) => {
    return 'nav-link ' + (paths.some((path) => {
      return ('/' + tabSelectorRoute(pathname)) === path || tabSelectorRoute(pathname) === path;
    }) ?
      'c-menu-select' :
      '');
  };

  const tabSelectorRoute = (route: string) => {
    const params = route.split('/');
    switch (params[1]) {
      case 'schedule' :
        return 'schedule';
      case 'practices' :
        return 'practices';
      case 'players' :
        return 'players';
      case 'player' :
        return 'player';
      case 'games' :
        return 'games';
      case 'team' :
        return 'team';
      case 'teams' :
        return 'teams';
      case 'profiles' :
        return 'profiles';
      case 'account' :
        return 'account';
      case 'view' :
        return 'view';
      case 'entities' :
        return 'entities';
      case 'monitor' :
        return 'monitor';
      case 'health' :
        return 'health';
      case 'dataops' :
        return 'dataops';
      case 'customers' :
        return 'customers';
      case 'status' :
        return 'status';
      case 'about' :
        return 'about';
      default :
        return null;
    }
  };
  const addSearchPlayers = (amount: number, detecteds: JSX.Element[]) => {
    let count = 0;
    const newDetectedPlayers = [];
    for (; indexSearch < players.length; ++indexSearch) {
      if (count >= amount) {
        break;
      }
      const player = players[indexSearch];
      if ((player.name.toLowerCase().indexOf(textSearched.toLowerCase()) === -1)) {
        continue;
      }
      ++count;
      newDetectedPlayers.push(
        <Link
          onClick={() => {
            const dataPlayer = buildPlayerData(player);
            replaceDataPlayers({ [dataPlayer.meta.playerId]: dataPlayer })();
            saveDataPlayersOnLocalStorage();
            setShownBar(false);
            setDetectedPlayers([]);
          }}
          key={`${JSON.stringify(player)}_${indexSearch}`}
          to={{
            pathname: `/player/${player.nid}`,
            state: {
              player: player
            }
          }}
        >
          <span className={'output-search-box-label'} key={player.name}>
            {player.name} ({player.position}-{player.teamAbbr})
          </span>
        </Link>
      );

    }
    setDetectedPlayers([...detecteds, ...newDetectedPlayers]);
  };
  const countShow = 50;
  const [textSearched, setTextSearched] = useState('');
  useEffect(() => {
    setDetectedPlayers([]);
    indexSearch = 0;
    if (textSearched) {
      addSearchPlayers(countShow, []);
    }
  }, [textSearched, players]);
  const handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    if (target.value) {
      setTextSearched(target.value);
    }
  };
  const teamsNavItem = isNCAA(user) || isNCAAAllSports(user) ? null :
    <NavLink className={onPath(['/teams', '/team'])} to="/teams" id={'nav-teams'}>
      Teams
    </NavLink>;
  const currentDate = new Date();
  const accountUser = isMobile ? (
    <Dropdown className="cc-logout-dropdown">
      <Dropdown.Toggle id={'button-account'}>
        <h6 style={isCC(user) || isNCAA(user) ? { color: `black` } : TEAMS_COLORS[user.teamShort]? { color: `${TEAMS_COLORS[user.teamShort].text}` } : { color: `black` } }>
          {user.name}
        </h6>
        <label>{user.teamName}</label>
        <img
          src={`/assets/images/logos/${user.teamShort === 'CC' ? 'ZEBRA' : user.teamShort}.svg`}
          alt=""
          width="40px"
        />
      </Dropdown.Toggle>
      {isCC(user) || isMobile && (
        <div className='dropdown-menu'>
          <div id="google-logout" className="logout-dropdown" onClick={() => logout(history, logoutUser())}>
            <GoogleLogout
              clientId={GOOGLE_CLIENT_ID || ''}
              buttonText="Sign Out"
              onLogoutSuccess={() => logout(history, logoutUser())}
              onFailure={failure}
            >
            </GoogleLogout>
          </div>
        </div>
      )}
    </Dropdown>
  ):(
    <Dropdown className="cc-logout-dropdown">
      <Dropdown.Toggle id={'button-account'}>
        <h6 style={isCC(user) || isNCAA(user) ? { color: `black` } : TEAMS_COLORS[user.teamShort]? { color: `${TEAMS_COLORS[user.teamShort].text}` } : { color: `black` } }>
          {user.name}
        </h6>
        <label>{user.teamName}</label>
        <img
          src={`/assets/images/logos/${user.teamShort === 'CC' ? 'ZEBRA' : user.teamShort}.svg`}
          alt=""
          width="40px"
        />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item as="button" className={"btn-border btn-api-key"} onClick={() => startApiKeyOAuth(user.email)}>
          <i className="mdi mdi-key-variant"></i>
          API Key
        </Dropdown.Item>
        <Dropdown.Item className={"logout-dropdown"} onClick={() => logout(history, logoutUser())}>
          <GoogleLogout
            clientId={GOOGLE_CLIENT_ID || ''}
            buttonText="Sign Out"
            onLogoutSuccess={() => logout(history, logoutUser())}
            onFailure={failure} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  return (
    <>
      <Navbar bg="light" expand="lg" fixed="top">
        <Container>
          <NavLink to="/login">
            <img src="/assets/logo.svg" alt="" width="220px" className="" />
          </NavLink>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className={`c-menu  ${isCC(user) ? 'cc-menu' : ''}`}>
              <NavLink
                className={onPath(['schedule'])} to={`/schedule/week/${formatDateRoute(currentDate)}`}
                id={'nav-schedule'}
              >
                Schedule
              </ NavLink>
              {(isCC(user) || isTA(user) || !isNCAA(user) && (user.sbRole !== S_B_ROLES.CUSTOMER)) &&
              <><NavLink className={onPath(['/profiles'])} to="/profiles/profile" id={'nav-profiles'}>
                Profiles
              </NavLink></>}
              {isCC(user) && <>
                <NavLink className={onPath(['/entities'])} to="/entities/noc" id={'nav-entities'}>
                  Entities
                </NavLink></>}
              {(!isCC(user) && !isMobile) &&
              <>
                <NavLink
                  className={onPath(['/practices', '/live-practices', '/past-practices', '/practice'])}
                  to="/practices" id={'nav-practices'}
                >
                  Practices
                </NavLink>
                {!isMLAX(user) && (
                  <NavLink className={onPath(['/games', '/game'])} to="/games" id={'nav-games'}>
                    Games
                  </NavLink>
                )}
                {teamsNavItem}
                <NavLink className={onPath(['/players', '/player'])} to="/players" id={'nav-players'}>
                  Players
                </NavLink>
                { (isTA(user) || isNCAAAllSports(user) ) &&
                <NavLink className={onPath(['/account', '/account'])} to={'/account'} id={'nav-account'}>
                  Customers
                </NavLink>
                }
                <NavLink className={onPath(['/about'])} to="/about" id={'nav-about'}>
                  About
                </NavLink>
              </>
              }
              {isCC(user) && (
                <>
                  <NavLink
                    className={onPath(['/monitor'])}
                    to={`/monitor/${DateFns.format(currentDate, FORMAT_DATE_ROUTE)}`}
                    id={'nav-monitor'}
                  >
                    Monitor
                  </NavLink>
                  <NavLink className={onPath(['/health'])} to="/health/health" id={'nav-health'}>
                    Health
                  </NavLink>
                  <NavLink className={onPath(['/status'])} to="/status" id={'nav-status'}>
                    Processing Status
                  </NavLink>
                  <NavLink className={onPath(['/dataops'])} to="/dataops/page" id={'nav-ops'}>
                    Data Ops
                  </NavLink>
                  <NavLink className={onPath(['/customers'])} to="/customers" id={'nav-customers'}>
                    Customers
                  </NavLink>
                  <NavDropdown className="nav-drop" title="More" id="basic-nav-dropdown">
                    <NavLink
                      className={'dropdown-item'}
                      to="/about" id={'nav-about'}>
                      About
                    </NavLink>
                    <NavDropdown.Divider />
                    <NavLink
                      className={'dropdown-item'}
                      to="/practices" id={'nav-practices'}
                    >
                      Practices
                    </NavLink>
                    <NavDropdown.Divider />
                    <NavLink className={'dropdown-item'} to="/games" id={'nav-games'}>
                      Games
                    </NavLink>
                    <NavDropdown.Divider />
                    <NavLink className={'dropdown-item'} to="/teams" id={'nav-teams2'}>
                      Teams
                    </NavLink>
                    <NavDropdown.Divider />
                    <NavLink className={'dropdown-item'} to="/players" id={'nav-players2'}>
                      Players
                    </NavLink>
                  </NavDropdown>
                </>
              )}
              <Nav className="p-search">
                <Form role="search" className="search-form">
                  <div
                    className="search-text"
                    placeholder="Search..."
                    onClick={() => {
                      setTextSearched('');
                      setShownBar(prevState => !prevState);
                    }}
                  />
                </Form>
              </Nav>
            </Nav>
            <Nav className="r-menu">
              <div>
                 {accountUser}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {shownBar && (
        <div
          onBlur={() => {
            if (!detectedPlayers.length) {
              setShownBar(false);
            }
          }}
          style={{ height: '0px' }}
        >
          <Navbar bg="light" expand="lg" className={'search-bar'}>
            <Container>
              <div className={'input-search-box'}>
                <input
                  className={'input-search'}
                  placeholder={'Search players'}
                  type={'text'}
                  onChange={handleChange}
                  autoFocus
                />
                <div
                  className={'cancel-search'} onClick={() => {
                  setShownBar(false);
                  setDetectedPlayers([]);
                }}
                >
                  <img src="/assets/close_.svg" alt="" width="15px" className="" />
                </div>
              </div>
            </Container>
          </Navbar>
          {(detectedPlayers.length > 0 || current.count) && (
            <Navbar bg="light" expand="lg" className={'search-bar'} style={{ top: '110px' }}>
              <Container>
                <Loader
                  forceScope={FORCE_SCOPE.PLAYERS_SEARCH_DATA_NAVBAR}
                  style={{ height: '150px', position: 'unset' }}
                >
                  <div
                    className={'input-search-box'}
                    style={{ overflow: 'auto' }}
                    onScroll={(e: any) => {
                      const element = e.target;
                      if ((element.scrollHeight - element.scrollTop - element.clientHeight) < 1) {
                        addSearchPlayers(countShow, detectedPlayers);
                      }
                    }}
                  >
                    <span className={'output-search-box-title'}>Players</span>
                    <div>{detectedPlayers}</div>
                  </div>
                </Loader>
              </Container>
            </Navbar>
          )}
        </div>
      )}
    </>
  );
};

export default NavBar;
